<div id="private-list-container" class="hmf-display-flex hmf-flex-column hmf-align-items-center hmf-text-align-center">
  <div id="private-list-message-container" class="hmf-display-flex hmf-flex-column hmf-align-items-center hmf-text-align-center">
    <homefield-icon height="72px" width="72px" fill="var(--hmf-label-base-subtle)" name="security-lock-fill" class="hmf-mb-l"></homefield-icon>
    <p [ngClass]="'hmf-header-bold-l'" class="hmf-mb-xxs hmf-mb-m-s">This List is Private</p>
    <p class="hmf-body-m hmf-mb-xxs hmf-mb-m-s">We're sorry. This list has been set as private. Please reach out to the sender to discuss privacy options.</p>
    <div>
      @if (!isAuthenticated()) {
        <div class="center-text hmf-col hmf-span-12 hmf-mb-m hmf-display-flex hmf-flex-row hmf-justify-content-between">
          <hmf-button
            [variant]="'primary'"
            [text]="'SIGN IN'"
            [size]="'medium'"
            [loading]="false"
            [disabled]="false"
            [label]="'sign-in'"
            class="primary-button hmf-text-align-center hmf-mr-s hmf-body-bold-m"
            (click)="signIn()"
          onkeyup="signIn()"></hmf-button>
          <hmf-button
            [variant]="'secondary'"
            [text]="'CREATE ACCOUNT'"
            [size]="'medium'"
            [loading]="false"
            [disabled]="false"
            [label]="'create-account'"
            class="secondary-button hmf-text-align-center hmf-body-bold-m"
            (click)="createAccount()"
          onkeyup="createAccount()"></hmf-button>
        </div>
      } @else {
        <hmf-button
          class="private-shared-list-auth-button"
          [variant]="'primary'"
          [text]="'GO TO YOUR LISTS'"
          [size]="'medium'"
          [loading]="false"
          [disabled]="false"
          [label]="'go-to-your-lists'"
        [routerLink]="['/MyAccount/Lists']"></hmf-button>
      }
    </div>
  </div>
</div>

